import "./App.css";
import Navbar from "./Components/Navbar/Navbar.jsx";
import About from "./Components/about/About.jsx";
import Home from "./Components/Home/Home";
import Project from "./Components/Projects/Project";
import Contact from "./Components/Contact/Contact";
function App() {
  return (
    <div className="App scroll-smooth overflow-hidden ">
      <Navbar />
      <div className="mt-[92px]">
        <Home />
      </div>
      <About />
      <Project />
      <Contact />
    </div>
  );
}

export default App;
